import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReview: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReview"><Path d="M3.5 3.5H20.5V20.5H3.5V3.5Z" stroke="currentColor"/><Path d="M12 7.5L13.1903 10.3617L16.2798 10.6094L13.9259 12.6258L14.645 15.6406L12 14.025L9.35497 15.6406L10.0741 12.6258L7.72025 10.6094L10.8097 10.3617L12 7.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconReview;
